import Header from "./Header";

export { default as HeaderPublicGradient } from "./HeaderPublicGradient";
export { default as HeaderGradient } from "./HeaderGradient";

export default Header;
